import {
    URLAPI,
    WORK_SUBPROCESS_PATH,
    WORK_SUBPROCESS_CREATE_PATH,
    WORK_SUBPROCESS_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_work_subprocess: {
        data: [],
        status: 0,
        message: {},
    },
    _create_work_subprocess: {
        data: {},
        status: 0,
        message: {},
    },
    _update_work_subprocess: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_WORK_SUBPROCESS = "GET_ALL_WORK_SUBPROCESS";
export const CREATE_WORK_SUBPROCESS = "CREATE_WORK_SUBPROCESS";
export const UPDATE_WORK_SUBPROCESS = "UPDATE_WORK_SUBPROCESS";

export const work_subprocess_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_WORK_SUBPROCESS:
            return {
                ...state,
                _get_all_work_subprocess: action.payload,
            };
        case CREATE_WORK_SUBPROCESS:
            return {
                ...state,
                _create_work_subprocess: action.payload,
            };
        case UPDATE_WORK_SUBPROCESS:
            return {
                ...state,
                _update_work_subprocess: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllWorkSubProcess = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${WORK_SUBPROCESS_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_WORK_SUBPROCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_WORK_SUBPROCESS,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_WORK_SUBPROCESS,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createWorkSubProcess = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${WORK_SUBPROCESS_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_WORK_SUBPROCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_WORK_SUBPROCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_WORK_SUBPROCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateWorkSubProcess = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${WORK_SUBPROCESS_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_WORK_SUBPROCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_WORK_SUBPROCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_WORK_SUBPROCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const searchSubProcess = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${WORK_SUBPROCESS_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const clear_work_subprocess = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
